import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Languages } from "lucide-react";
 * // Use <Languages /> instead
 */
export const TranslationsIcon = createSVGWrapper(
  <>
    <path
      fill="currentColor"
      d="M4 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-2H4V4h10v5h2V4a2 2 0 0 0-2-2H4Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 8c0 .348-.048.682-.136 1H11a2 2 0 0 0-2 2v1.118C7.853 12.683 6.468 13 5 13v-2a7.61 7.61 0 0 0 2.1-.287C6.43 9.965 6 9.044 6 8H5V6h3V5h2v1h3v2h-1Zm-2 0c0 .584-.312 1.214-1 1.768C8.312 9.214 8 8.584 8 8h2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.977 16.913h2.046l-1.034-2.904-1.012 2.904Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V11Zm2.392 8.85a.25.25 0 0 1-.165-.066.25.25 0 0 1-.066-.165c0-.037.004-.07.011-.099l2.585-7.062a.426.426 0 0 1 .132-.209.427.427 0 0 1 .297-.099h1.628c.125 0 .22.033.286.099a.4.4 0 0 1 .143.209l2.574 7.062c.015.03.022.062.022.099a.231.231 0 0 1-.077.165.224.224 0 0 1-.165.066h-1.353c-.11 0-.194-.026-.253-.077a.484.484 0 0 1-.099-.154l-.429-1.122h-2.937l-.418 1.122a.484.484 0 0 1-.099.154c-.051.051-.14.077-.264.077h-1.353Z"
      clipRule="evenodd"
    />
  </>
);
